import api, { cable } from '@/api'
import { AppHolder } from '@/utils/app-holder'
import humps from 'humps'

export default {
  fetch (page = 1) {
    return api.get('/users/me/notifications', { params: { page } })
  },

  read (id) {
    return api.put(`/users/me/notifications/${id}`, {
      read: true
    })
  },

  readAll () {
    return api.put('/users/me/notifications/all')
  },

  subscribe () {
    if (!this._subscription) {
      cable.getSubscriptions().then(subscriptions => {
        this._subscription = subscriptions.create({
          channel: 'NotificationsChannel'
        }, {
          received (data) {
            AppHolder.store.dispatch('notifications/add', humps.camelizeKeys(data))
          }
        })
      })
    }
  },

  unsubscribe () {
    const { _subscription } = this
    if (_subscription) {
      _subscription.unsubscribe()
      this._subscription = null
    }
  }
}
